import { Injectable } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BehaviorDataService {
    private userConfig = new BehaviorSubject('');
    getUserConfig = this.userConfig.asObservable();

    private adaInteractionMessage = new BehaviorSubject(false);
    showAdaInteractionMessage = this.adaInteractionMessage.asObservable();

    private hideInputPage = new BehaviorSubject(false);
    getHideInputPage = this.hideInputPage.asObservable();

    private isInPlayBreak = new BehaviorSubject(false);
    getIsInPlayBreak = this.isInPlayBreak.asObservable();

    private isSessionTimeoutStatus = new BehaviorSubject(false);
    getIsSessionTimeoutStatus = this.isSessionTimeoutStatus.asObservable();

    private arcDepositBlockStatus = new Subject();
    getArcDepositBlockStatus = this.arcDepositBlockStatus.asObservable();

    private kycPLverification = new BehaviorSubject(false);
    getKycPLverification = this.kycPLverification.asObservable();

    private bwinPLkycverification = new BehaviorSubject(null);
    getbwinPLkycverification = this.bwinPLkycverification.asObservable();

    private flashVoucherErrorDetails = new BehaviorSubject(null);
    getFlashVoucherErrorDetails = this.flashVoucherErrorDetails.asObservable();

    private kycPLlimitverification = new BehaviorSubject(null);
    getkycPLlimitverification = this.kycPLlimitverification.asObservable();

    private productSelectionError = new BehaviorSubject(false);
    getProductSelectionError = this.productSelectionError.asObservable();

    private hideProductRadioButtons = new BehaviorSubject(false);
    getHideProductRadioButtons = this.hideProductRadioButtons.asObservable();

    private showCCDepositLimitCheckMsg = new BehaviorSubject(false);
    getCCDepositLimitCheckMsg = this.showCCDepositLimitCheckMsg.asObservable();

    private enteredAmount = new BehaviorSubject('');
    getEnteredAmount = this.enteredAmount.asObservable();

    private cvv2 = new BehaviorSubject('');
    getCVV2 = this.cvv2.asObservable();

    private productPreference = new BehaviorSubject('');
    getProductPreference = this.productPreference.asObservable();

    private purchaseLimitsErrorDetails = new BehaviorSubject(null);
    getPurchaseLimitsErrorDetails = this.purchaseLimitsErrorDetails.asObservable();

    private rgLimitsErrorDetails = new BehaviorSubject(null);
    getRgLimitsErrorDetails = this.rgLimitsErrorDetails.asObservable();

    private instrumentDepositLimitErrorDetails = new BehaviorSubject(null);
    getInstrumentDepositLimitErrorDetails = this.instrumentDepositLimitErrorDetails.asObservable();

    private submitResponse = new BehaviorSubject(null);
    getSubmitResponse = this.submitResponse.asObservable();

    private sessionInfo = new BehaviorSubject(null);
    getSessionInfo = this.sessionInfo.asObservable();

    private sportsLimitsErrorDetails = new BehaviorSubject(null);
    getSportsLimitsErrorDetails = this.sportsLimitsErrorDetails.asObservable();

    private gamingLimitsErrorDetails = new BehaviorSubject(null);
    getGamingLimitsErrorDetails = this.gamingLimitsErrorDetails.asObservable();

    private isPaypalBadFunding = new BehaviorSubject(false);
    getPaypalBadFunding = this.isPaypalBadFunding.asObservable();

    changeMaxFailDepEnhancement = new BehaviorSubject(null);
    userODetails: any;

    setUserConfig(data: any) {
        this.userConfig.next(data);
    }
    setODDetails(data: any) {
        this.userODetails = data;
    }

    changeAdaInteractionMessage(data: boolean) {
        this.adaInteractionMessage.next(data);
    }

    changeHideInputPage(data: boolean) {
        this.hideInputPage.next(data);
    }

    changeInPlayBreak(data: boolean) {
        this.isInPlayBreak.next(data);
    }

    changeSessionTimeoutStatus(data: boolean) {
        this.isSessionTimeoutStatus.next(data);
    }

    changeArcDepositBlockStatus(data: any) {
        this.arcDepositBlockStatus.next(data);
    }

    changekycPLverification(data: boolean) {
        this.kycPLverification.next(data);
    }

    changebwinPLkycverification(data: any) {
        this.bwinPLkycverification.next(data);
    }

    changeFlashVoucherErrorDetails(data: any) {
        this.flashVoucherErrorDetails.next(data);
    }

    changekycPLlimitverification(data: any) {
        this.kycPLlimitverification.next(data);
    }

    changeProductSelectionError(data: boolean) {
        this.productSelectionError.next(data);
    }

    changeHideProductRadioButtons(data: boolean) {
        this.hideProductRadioButtons.next(data);
    }

    changeshowCCDepositLimitCheckMsg(data: boolean) {
        this.hideProductRadioButtons.next(data);
    }

    changeEnteredAmount(data: string) {
        this.enteredAmount.next(data);
    }

    changeCVV2(data: string) {
        this.cvv2.next(data);
    }

    changeProductPreference(data: string) {
        this.productPreference.next(data);
    }

    changePurchaseLimitsErrorDetails(data: any) {
        this.purchaseLimitsErrorDetails.next(data);
    }

    changeRgLimitsErrorDetails(data: any) {
        this.rgLimitsErrorDetails.next(data);
    }

    changeInstrumentDepositLimitErrorDetails(data: any) {
        this.instrumentDepositLimitErrorDetails.next(data);
    }

    changeSubmitResponse(data: any) {
        this.submitResponse.next(data);
    }

    changeSessionInfo(data: any) {
        this.sessionInfo.next(data);
    }

    changeSportsLimitsErrorDetails(data: any) {
        this.sportsLimitsErrorDetails.next(data);
    }

    changeGamingLimitsErrorDetails(data: any) {
        this.gamingLimitsErrorDetails.next(data);
    }

    changePaypalBadFunding(data: boolean) {
        this.isPaypalBadFunding.next(data);
    }
}
